import { memo, useState } from "react";
import { scrollToAnchor } from "../libs/utils";
//photo
import titleIcon from "../assets/img/Desktop/Meteor_component_1_D.png";
import meteorIcon from "../assets/img/Desktop/Meteor_component_2_D.png";
import facebookIcon from "../assets/img/Desktop/Meteor_component_3_D.png";
import igIcon from "../assets/img/Desktop/Meteor_component_4_D.png";
import meteorMobileIcon from "../assets/img/Mobile/Meteor_component_10_M.png";
import facebookMobileIcon from "../assets/img/Mobile/Meteor_component_11_M.png";
import igMobileIcon from "../assets/img/Mobile/Meteor_component_12_M.png";
import hamburgerIcon from "../assets/img/Mobile/Meteor_component_2_M.png";

const NavbarItem = ({ children, anchorName }) => {
  return (
    <li>
      <button
        className="inline-block h-full text-white cursor-pointer px-12px text-lg hover:bg-white-20%"
        onClick={() => {
          scrollToAnchor(anchorName);
        }}
      >
        {children}
      </button>
    </li>
  );
};

const NavbarIconItem = ({ link, img, alt }) => {
  return (
    <li>
      <a
        className="inline-block h-full flex item-center md:py-5px md:hover:bg-white-20% rounded-full md:rounded-none active:bg-green-1-15% md:active:bg-inherit"
        href={link}
        target="_blank"
        rel="noreferrer"
      >
        <img src={img} alt={alt} className="w-52px md:w-40px md:h-40px" />
      </a>
    </li>
  );
};

const NavbarMobileItem = ({ children, anchorName, setMenuShow }) => {
  return (
    <li className="py-8px">
      <button
        className="inline-block font-semibold cursor-pointer text-green-1 text-lg py-8px w-120px rounded-full active:bg-green-1-15%"
        onClick={() => {
          scrollToAnchor(anchorName);
          setMenuShow(false);
        }}
      >
        {children}
      </button>
    </li>
  );
};

const NavbarMobileHr = () => {
  return (
    <hr className="w-120px border border-green-1-50% border-solid mx-auto" />
  );
};
const Header = () => {
  const [menuShow, setMenuShow] = useState(false);
  return (
    <nav className="bg-headerAndFooter px-16px sm:px-40px flex justify-between items-center fixed inset-x-0 z-10 shadow-navbar">
      <a className="block py-5px" href="/">
        <img
          src={titleIcon}
          alt="米特桌面titleIcon"
          className="w-112px sm:w-124px"
        />
      </a>
      <div className=" hidden md:flex">
        <ul className="flex mr-12px">
          <NavbarItem anchorName={"applicationQualification"}>
            申請資格
          </NavbarItem>
          <NavbarItem anchorName={"applicationProcedures"}>申請流程</NavbarItem>
          <NavbarItem anchorName={"commonQuestion"}>常見問題</NavbarItem>
        </ul>
        <ul className="flex items-center">
          <NavbarIconItem
            img={meteorIcon}
            alt={"meteorIcon"}
            link={"https://meteor.today/board/all"}
          />
          <NavbarIconItem
            img={facebookIcon}
            alt={"FacebookIcon"}
            link={"https://www.facebook.com/MeteorApp/"}
          />
          <NavbarIconItem
            img={igIcon}
            alt={"IGIcon"}
            link={
              "https://www.instagram.com/meteor.tw/?utm_source=ig_embed&ig_rid=aeaf5406-9fcf-409d-8784-777d50be9118"
            }
          />
        </ul>
      </div>
      {/* 手機版 */}
      <button className="cursor-pointer  inline-block md:hidden">
        <img
          src={hamburgerIcon}
          alt="漢堡選單"
          className="w-40px"
          onClick={() => {
            setMenuShow(!menuShow);
          }}
        />
      </button>
      {/* {menuShow && ( */}
      <div
        className={`md:hidden absolute top-46px bg-navbar-mobile right-0 left-0 text-green-1 py-48px rounded-b-15px shadow-navbar ${
          menuShow ? "visible opacity-100" : "invisible opacity-0"
        } transition-all duration-300 z-0`}
      >
        <ul className="text-center ">
          <NavbarMobileItem
            anchorName={"applicationQualification"}
            setMenuShow={setMenuShow}
          >
            申請資格
          </NavbarMobileItem>
          <NavbarMobileHr />
          <NavbarMobileItem
            anchorName={"applicationProcedures"}
            setMenuShow={setMenuShow}
          >
            申請流程
          </NavbarMobileItem>
          <NavbarMobileHr />
          <NavbarMobileItem
            anchorName={"commonQuestion"}
            setMenuShow={setMenuShow}
          >
            常見問題
          </NavbarMobileItem>
        </ul>
        <ul className="flex items-center justify-center mt-8px">
          <NavbarIconItem
            img={meteorMobileIcon}
            alt={"meteorIcon"}
            link={"https://meteor.today/board/all"}
          />
          <NavbarIconItem
            img={facebookMobileIcon}
            alt={"FacebookIcon"}
            link={"https://www.facebook.com/MeteorApp/"}
          />
          <NavbarIconItem
            img={igMobileIcon}
            alt={"IGIcon"}
            link={
              "https://www.instagram.com/meteor.tw/?utm_source=ig_embed&ig_rid=aeaf5406-9fcf-409d-8784-777d50be9118"
            }
          />
        </ul>
      </div>
      {menuShow && (
        <div
          className="md:hidden fixed top-46px right-0 left-0 bottom-0 -z-10"
          onClick={() => {
            setMenuShow(false);
          }}
        ></div>
      )}
    </nav>
  );
};
export default memo(Header);
